import { AttributionEvidenceType } from "@redotech/redo-attribution-common/attribution-settings";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const orderCreditSchema = z.object({
  weight: z.number(),
  supportMessageId: z.string().nullable(),
  evidence: z.array(
    z.object({ type: z.enum(AttributionEvidenceType), at: zExt.instant() }),
  ),
});
export type OrderCredit = z.infer<typeof orderCreditSchema>;

const orderAttributionSchema = z.discriminatedUnion("status", [
  z.object({
    status: z.literal("credited"),
    credits: z.array(orderCreditSchema),
  }),
  z.object({ status: z.literal("not_credited") }),
  z.object({ status: z.literal("pending") }),
  z.object({ status: z.literal("outside_window") }),
]);
export type OrderAttribution = z.infer<typeof orderAttributionSchema>;

export const orderAttributionByOrderIdSchema = z.record(
  z.string(),
  orderAttributionSchema,
);
export type OrderAttributionByOrderId = z.infer<
  typeof orderAttributionByOrderIdSchema
>;

export const agentCreditSnapshotSchema = z.object({
  computedAt: zExt.instant(),
  from: zExt.instant(),
  credits: z.array(
    orderCreditSchema.extend({
      orderId: z.string(),
      orderedAt: zExt.instant(),
      conversationTopicId: z.string().nullable(),
    }),
  ),
});
export type AgentCreditSnapshot = z.infer<typeof agentCreditSnapshotSchema>;
